import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { RevelationSection } from './components/RevelationSection';
import { SolutionSection } from './components/SolutionSection';
import { DifferentiationSection } from './components/DifferentiationSection';
import { CTASection } from './components/CTASection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SaleNotification } from './components/SaleNotification';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '1703383767307378';
export function App() {
  useEffect(() => {
    // Avoid double-init
    if (document.getElementById('fb-pixel-script')) return;
    // Build the fbq shim
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    window._fbq = n;
    // Inject the real SDK into <head>
    const script = document.createElement('script');
    script.id = 'fb-pixel-script';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Queue init + PageView (the SDK will flush the queue once loaded)
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-cream text-brown selection:bg-sage/30" data-id="element-0">
      {/* noscript fallback pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <RevelationSection data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <DifferentiationSection data-id="element-7" />
      <CTASection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <SaleNotification data-id="element-10" />
    </main>;
}